import React, { useState, useEffect } from 'react'
import JidoLightbox from './JidoLightbox'
import { Collapse } from 'antd'
const { Panel } = Collapse

const JidoItem = ({ jidodata }) => {
    const [scenarioa, setScenarioA] = useState([])
    const [scenariob, setScenarioB] = useState([])

    console.log(jidodata)

    useEffect(() => {
        setScenarioA(jidodata.acf.scenario_a_jido);
        setScenarioB(jidodata.acf.scenario_b_jido);

    }, [])

    return (
        <>
            <Collapse>
                <Panel header={
                    <p className='brand-text gradient-small bottom15px'
                        dangerouslySetInnerHTML={{ __html: jidodata.title.rendered }}
                    />
                } key="1">
                    <p className='brand-text small-heading bottom7px'>
                        Scenario A <i>(click to expand)</i>
                    </p>
                    <div className="bottom15px">
                        <JidoLightbox jidoscenario={scenarioa} />
                    </div>

                    <p className='brand-text small-heading bottom7px'>
                        Scenario B <i>(click to expand)</i>
                    </p>
                    <div>
                        <JidoLightbox jidoscenario={scenariob} />
                    </div>
                </Panel>
            </Collapse>
        </>


        // <div className="border-[2px] rounded border-gray-200 p-3">
        //     <p className='brand-text text-center gradient-small bottom15px'>
        //         {jidodata.title.rendered}
        //     </p>
        //     <p className='brand-text small-heading bottom7px'>
        //         Scenario A <i>(click to expand)</i>
        //     </p>
        //     {/* <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-2 bottom15px"> */}
        //     <div className="bottom15px">
        //         <JidoLightbox jidoscenario={scenarioa} />
        //         {/* {scenarioa.map((item, index) => (
        //             <div key={index} className="flex justify-center">
        //                 <img src={item.image_jido} alt={`Image ${index}`} className="max-w-full h-auto" />
        //             </div>
        //         ))} */}
        //     </div>
        //     <p className='brand-text small-heading bottom7px'>
        //         Scenario B <i>(click to expand)</i>
        //     </p>
        //     {/* <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2"> */}
        //     <div>
        //         <JidoLightbox jidoscenario={scenariob} />
        //         {/* {scenariob.map((item, index) => (
        //             <div key={index} className="flex justify-center">
        //                 <img src={item.image_jido} alt={`Image ${index}`} className="max-w-full h-auto" />
        //             </div>
        //         ))} */}
        //     </div>
        // </div>
    )
}

export default JidoItem